module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cgs"
  }, [_c('div', {
    staticClass: "shadow"
  }), _vm._v(" "), _c('div', {
    staticClass: "cgs_wrap"
  }, [_c('img', {
    attrs: {
      "src": require("@img/cgs.png"),
      "alt": "logo"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Congratulations!")]), _vm._v(" "), _c('p', {
    staticClass: "words"
  }, [_vm._v("Your account has been created successfully. Let's get you \nstarted in your application to become a HAWO teacher.")]), _vm._v(" "), _c('a', {
    staticClass: "started",
    on: {
      "click": _vm.started
    }
  }, [_vm._v("Let's get started")]), _vm._v(" "), _c('p', {
    staticClass: "timeout"
  }, [_vm._v(_vm._s(_vm.time_out))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe3c3870"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/other/congratulations.vue
// module id = 868
// module chunks = 1